import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "features/store";

type ProtectedRouteProps = {
  children: JSX.Element;
};

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);
  const location = useLocation();

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  // If authenticated but password reset is required, redirect to reset password
  if (isAuthenticated && user && !user.is_pass_reset) {
    return <Navigate to="/reset-password" replace />;
  }

  // Special check for chat route - user must have chat bot access
  if (location.pathname === "/chat" && user && !user.is_chat_bot_allowed) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
